/// <amd-module name="Test/PassRateChartView/Stores/PassRateChartStore" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { PassRateChartActions } from "Test/PassRateChartView/Actions/PassRateChartActions";
import { Store } from "VSS/Reflux/Store";

export interface IPassRateChartState {
    testOutcomeMetricsData?: CommonTypes.ICardMetricsData;
}

export class PassRateChartStore extends Store {
    private _state: IPassRateChartState;

    constructor(private _actions: PassRateChartActions) {
        super("");
        this._initialize();
    }

    public getState(): IPassRateChartState {
        return this._state;
    }

    public dispose(): void {
        this._actions.updateConfigurationValuesAction.removeListener(this._onUpdateConfiguration);
        this._actions.updatePassRateChartAction.removeListener(this._onUpdatePassedRateChart);
    }

    private _initialize(): void {
        this._state = {} as IPassRateChartState;
        this._actions.updateConfigurationValuesAction.addListener(this._onUpdateConfiguration);
        this._actions.updatePassRateChartAction.addListener(this._onUpdatePassedRateChart);
    }

    private _onUpdatePassedRateChart = (passedRateChartData: CommonTypes.ICardMetricsData) => {
        this._state.testOutcomeMetricsData = passedRateChartData;
        this.emitChanged();
    };

    private _onUpdateConfiguration = () => {
        this._state.testOutcomeMetricsData = undefined; // This is done since after config change it will take time for data to come and component can show loading experience till then.
        this.emitChanged();
    };
}
